export enum ExplorationType {
    FIREBASE = "Firebase",
    MULTI_STEP = "Multi-step",
    AB_TEST = "AB-Test",
    INTELLIGENCE_SEARCH = "INTELLIGENCE-SEARCH",
    INTELLIGENCE_SEARCH_V2 = "INTELLIGENCE-SEARCH-MULTI-QUESTIONS",
}
